import baseAPI from "../app/baseAPI";

export const loginReducer = baseAPI.injectEndpoints({
    endpoints(builder) {
        return {
         
            loginResponse: builder.mutation({
            query(params) {
                console.log('prams',params.paramsData)
                // console.log('prams2',params)
              return {
                url: `/user/login/`,
                method: "POST",
                prefixUrlType:"Profile",
                // token: true,
            
                body: {
                  ...params.paramsData,
                },
              };
            },
            keepUnusedDataFor: 5,
            transformResponse: (responseData) => responseData,
          }),
        
        };
      },
    });
export const {
  useLoginResponseMutation,

} = loginReducer;
